import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAxios } from "../../hooks/useAxios";
import { UserRole } from "../../types";

export interface IMutateWorkspaceUserRoleProps {
  onError?: () => void;
  onSettled?: () => void;
  onSuccess?: () => void;
}

export interface IMutateWorkspaceUserRoleParams {
  user_id: string;
  role: UserRole;
}

// eslint-disable-next-line
export interface IMutateWorkspaceUserRoleResponse {}

export default function useMutateWorkspaceUserRole(
  props: IMutateWorkspaceUserRoleProps
): UseMutationResult<
  IMutateWorkspaceUserRoleResponse,
  unknown,
  IMutateWorkspaceUserRoleParams
> {
  const axios = useAxios();
  const queryClient = useQueryClient();

  const MutateWorkspaceUserRole = async (
    args: IMutateWorkspaceUserRoleParams
  ) => {
    const { user_id, role } = args;

    const response = await axios({
      method: "put",
      url: `/v1/workspaces/users/${user_id}/role`,
      data: {
        user_id,
        role,
      },
    }).then((r) => r.data as IMutateWorkspaceUserRoleResponse);

    queryClient.invalidateQueries(["workspaceUsers"]);

    return response;
  };

  const mutation = useMutation(MutateWorkspaceUserRole, {
    onError: props.onError,
    onSettled: props.onSettled,
    onSuccess: props.onSuccess,
  });

  return mutation;
}
